import React from 'react';

const inputStyle = (hasError) => ({
  width: '100%',
  background: 'transparent',
  border: 'none',
  borderBottom: hasError ? '2px solid #FF5722' : '2px solid rgba(156, 163, 175, 0.3)',
  borderRadius: 0,
  padding: '10px 0',
  fontFamily: 'var(--font-body)',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1.5,
  color: 'var(--color-foreground)',
  outline: 'none',
  transition: 'border-color 250ms ease-out',
  letterSpacing: '0.01em',
});

const labelStyle = {
  fontFamily: 'var(--font-caption)',
  fontSize: '11px',
  fontWeight: 500,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'var(--color-muted-foreground)',
  display: 'block',
  marginBottom: '8px',
};

const PersonalInfoSection = ({ formData, errors, onChange, onBlur }) => {
  const handleFocus = (e, hasError) => {
    if (!hasError) e.target.style.borderBottomColor = 'var(--color-primary)';
  };
  const handleBlur = (e, hasError) => {
    if (!hasError) e.target.style.borderBottomColor = 'rgba(156, 163, 175, 0.3)';
    onBlur?.(e);
  };

  return (
    <div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '22px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '24px', letterSpacing: '0.02em' }}>
        Personlig informasjon
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="sm:col-span-2">
          <label style={labelStyle}>Fullt navn</label>
          <input
            name="fullName"
            type="text"
            value={formData?.fullName || ''}
            onChange={onChange}
            placeholder="Ola Nordmann"
            style={inputStyle(errors?.fullName)}
            onFocus={e => handleFocus(e, errors?.fullName)}
            onBlur={e => handleBlur(e, errors?.fullName)}
          />
          {errors?.fullName && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.fullName}</p>}
        </div>
        <div>
          <label style={labelStyle}>E-postadresse</label>
          <input
            name="email"
            type="email"
            value={formData?.email || ''}
            onChange={onChange}
            placeholder="navn@eksempel.no"
            style={inputStyle(errors?.email)}
            onFocus={e => handleFocus(e, errors?.email)}
            onBlur={e => handleBlur(e, errors?.email)}
          />
          {errors?.email && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.email}</p>}
        </div>
        <div>
          <label style={labelStyle}>Telefonnummer</label>
          <input
            name="phone"
            type="tel"
            value={formData?.phone || ''}
            onChange={onChange}
            placeholder="+47 000 00 000"
            style={inputStyle(errors?.phone)}
            onFocus={e => handleFocus(e, errors?.phone)}
            onBlur={e => handleBlur(e, errors?.phone)}
          />
          {errors?.phone && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.phone}</p>}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
